<template>
    <v-dialog v-model="dialog.show" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                class="mx-2"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                fab
                small
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            dark
                        >
                            mdi-plus
                        </v-icon>
                    </template>
                    create new {{ tagType }}
                </v-tooltip>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">new {{ tagType }}</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-text-field v-model="tagItem.name" label="name"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialog.show=false"
                  :disabled="dialog.saving"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    :disabled="dialog.saving"
                    :loading="dialog.saving"
                    @click="save"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'TagForm',
  props: {
    tagType: {
      type: String,
      default: 'hashtag',
    },
  },
  data: () => ({
    dialog: {
      saving: false,
      show: false,
    },

    tagItem: {
      id: null,
      name: '',
    },
  }),
  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),
    save() {
      this.dialog.saving = false;

      let tagRoute = 'hashtags';

      switch (this.tagType) {
        case 'admintag':
        case 'admintags':
        case 'poitag':
        case 'poitags':
          tagRoute = 'poitag';
          break;
        case 'hashtags':
        case 'hashtag':
        default:
          tagRoute = 'hashtags';
          break;
      }

      this.$requestHelpers
        .post(`api/admin/${tagRoute}`, { name: this.tagItem.name })
        .then((response) => {
          if (response.data.success) {
            this.setSnack({
              color: 'green',
              text: 'created',
            });
            this.$emit('create', response.data.result);

            this.tagItem.name = '';
            this.tagItem.id = null;

            this.dialog.show = false;
            this.dialog.saving = false;
          }
        });
    },
  },
};
</script>
